<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
import CourseDetailsForm from '@/views/CourseDetailsForm.vue'
export default {
    components: { SvgTransition, CourseDetailsForm },
    data() {
        return {
            occations: [],
            instructors: []
        }
    },
    created() {  
        this.$cache.createCache('publicPage', 'public-page/',  {id: this.$route.params.id, domain: window.location.hostname });      
        this.getCourse();
    },
    computed: {
        url() { return config.urlToServer },  
        publicPageColorsDict() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColorsDict : null },         
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },
        availableCourses() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableCourses : [] },
        height() { return window.innerHeight/1.14 + 'px' },       
        settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
        hasSettings() { return this.settings },
        course() { return this.availableCourses.find(x => x.id == this.$route.params.courseid) }
    },
    methods:
    {
        getCourse()
        {
            var self = this;
            this.$communicator.get('get-public-course/' + this.$route.params.courseid)
            .then(function(data)
            {             
                self.occations = data.occations;
                self.instructors = data.instructors;
            })
            .fail(function(error) {              
            }); 
        }  
    }
}
</script>
<template>
   <section class="public-page" v-if="publicPage != null && course && hasSettings">   
        <div class="top-public position-relative" :style="{ 'height': height, 'background-image': 'url(' + url + 'uploads/'+ publicPage.customer_id+'/images/'+course.image_name + ')' }">
            <SvgTransition :publicPage="publicPage"></SvgTransition>   
        </div>
        <div class="text-section overflow-auto" style="padding-top: 70px;">
            <div class="g-70">
                <div class="CourseDetails-section">
                    <h1 :style="publicPageColorsDict.header_color_on_white_bg.style" class="margin-top-25px">{{ course.name }}</h1>  
                    <div v-html="course.description"></div>    
                    <div class="CourseDetails-panel" :style="{ 'background-color': publicPageColorsDict.background_color.color }">
                        <div>
                            <h6>Startar</h6>
                            {{ course.course_start }}
                        </div>
                        <div>
                            <h6>Sista anmälningsdag</h6>
                            {{ course.last_day_of_application }}
                        </div>
                        <div>
                            <h6>Pris</h6>
                            {{ course.price }} kr
                        </div>
                        <div>
                            <h6>Antal tillfällen</h6>
                            {{ course.number_of_occations }} st
                            <p v-for="(occation, index) in occations">
                                tillfälle {{ index+1 }}:    {{ occation.duration }}
                            </p>
                        </div>
                        <div>
                            <h6>Plats</h6>
                            {{ course.location_name }}
                        </div>
                        <div>
                            <h6>Max antal deltagare</h6>
                            {{ course.max_number_of_participents }} 
                            <span style="color: red" v-if="course.max_number_of_participents - course.number_of_approved_participants == 0">Kursen är fullbokad</span>
                            <span style="color: red" v-else-if="course.max_number_of_participents - course.number_of_approved_participants <= course.show_few_left_at_this_number">Fåtal platser kvar!</span>
                        </div>
                    </div>
                </div>
                <div style="margin: 40px 30px 0px 0px;" class="pc-only overflow-auto">
                    <CourseDetailsForm :course="course"></CourseDetailsForm>                   
                </div>               
            </div> 
            <div class="g-30">
                <div class="CourseDetails-instructors">
                    <h2 :style="publicPageColorsDict.header_color_on_white_bg.style">{{ settings.CourseInstructor.plural }}</h2>
                    <div v-for="instructor in instructors" :style="{ 'background-color': publicPageColorsDict.background_color.color }">
                        <img :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ instructor.image_name" />  
                        <h3 style="padding:0px 15px">{{ instructor.name }}</h3>
                        <p v-html="instructor.description"></p>
                    </div>                    
                </div>
            </div>  
        </div>      
            <div style="margin: 0px 25px 30px 25px" class="mobile-only">
                <CourseDetailsForm :course="course"></CourseDetailsForm>                   
            </div>             
   </section>
</template>
<style scoped>
    .CourseDetails-section {
        margin: 0px 30px 0px 0px;
    }
    .CourseDetails-panel {
        padding:15px;
        margin-top: 30px;
        filter: brightness(1.1);
        overflow: auto;
        
    }
    
    .CourseDetails-panel div {
        width:33%;
        padding-bottom:30px; 
        display: inline-block; 
        vertical-align: top;    
    }
    
    .CourseDetails-panel p {
        margin: 0px;   
    }
    
    .CourseDetails-instructors {
        padding: 15px;
    }
    
    .CourseDetails-instructors div {
        padding: 10px;
    }
    
    .CourseDetails-instructors p {
        font-size: 14px;
        text-align: justify;
        line-height: 24px;
        padding: 0px 15px;
    }
    
    .CourseDetails-instructors img {
       width:100%;
    }

    h6{
        font-size: 13pt;
        margin: 7px 0px;
        font-weight: 500;
    }
   

    button {
        width: calc(100% - 8px);
        margin-top: 25px;
        padding: 13px 0px;
        font-size: 12pt;
    }


@media only screen and (max-width: 900px) {
    .CourseDetails-instructors {
        padding: 30px 0px;
    }

      .CourseDetails-section {
        margin: 0px;
    }

    td {
        width:100%;
        padding-bottom:30px;
    }

    .CourseDetails-panel div {
        width:100%;       
    }

}
</style>